import React from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";

export const NavMenus = () => {
  const { pathname } = useLocation();

  const isActiveCn = (path) => {
    return path === pathname ? "active" : "";
  };


  return (
    <div className="navbar-wrap main-menu d-none d-lg-flex">
      <ul className="navigation">
        {/* home */}
 <li className={cn(isActiveCn("/"))}>
          <Link to="/"> Home </Link>
        </li>

         <li className={cn(isActiveCn("/about-us"))}>
          <Link to="/about-us"> About us </Link>
        </li>

      

        {/* pages */}
 <li
          className={cn("menu-item-has-children", {
            active: ["/services/company-secretarial Services", "/services/consultancy-services","/services/legal-services"].includes(pathname),
          })}  >
           <Link to='#' > Services </Link>
          <ul className="sub-menu">
            <li className={cn(isActiveCn("/services/company-secretarial-services"))}>
              <Link to="/services/company-secretarial-services"> 
Company Secretarial Services </Link>
            </li>
            <li className={cn(isActiveCn("/blog-details"))}>
              <Link to="/services/legal-services">Legal Services</Link>
            </li>
            
             <li className={cn(isActiveCn("/blog-details"))}>
              <Link to="/services/consultancy-services"> Consultancy Services </Link>
            </li>

          </ul>
        </li>




      

 <li className={cn(isActiveCn("/industries"))}>
          <Link to="/industries"> Industries </Link>
        </li>

         <li className={cn(isActiveCn("/blog"))}>
          <Link to="/blog"> Resources </Link>
        </li>


        {/* contact */}
        <li className={cn(isActiveCn("/contact-us"))}>
          <Link to="/contact-us">contacts</Link>
        </li>
      </ul>
    </div>
  );
};
